import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Box, Typography } from '@heycater/design-system';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';

import { embeddedAssetOptions } from 'hub/helpers/contentful';
import SectionImage from 'static_pages/marketing_pages/components/SectionImage';

function PageSectionA({ body, image, header }) {
  const formattedBody =
    body &&
    documentToReactComponents(
      body,
      embeddedAssetOptions(body.links?.assets?.block)
    );

  return (
    <>
      <StyledGridContainer container spacing={{ xs: 0, sm: 2 }}>
        <StyledGridLeft item xs={0} sm={4}>
          {image && <SectionImage width={408} height={373} {...image} />}
        </StyledGridLeft>
        <StyledGridRight item xs={12} sm={7} md={8}>
          <Typography
            variant="h3"
            pb={{ xs: 1, sm: 3 }}
            pl={{ sm: 3 }}
            mt={2}
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            {header}
          </Typography>
          <Typography variant="body1" pl={{ xs: 0, sm: 3 }}>
            {body && <Box>{formattedBody}</Box>}
          </Typography>
        </StyledGridRight>
      </StyledGridContainer>
    </>
  );
}

const StyledGridLeft = styled(Grid)`
  margin: auto;

  ${(props) => props.theme.breakpoints.down('sm')} {
    align-self: center;
  }
`;

const StyledGridRight = styled(Grid)`
  align-self: center;
`;

const StyledGridContainer = styled(Grid)`
  margin: ${(props) => props.theme.spacing(7, 0, 8, 0)};

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin: ${(props) => props.theme.spacing(7, 2, 4, 0)};
  }

  ${(props) => props.theme.breakpoints.down('xs')} {
    margin: ${(props) => props.theme.spacing(3, 0, 3, 0)};
  }
`;

export default PageSectionA;
